// AllocationTable — per-tranche/class allocation (F3.3).

import type { BreakpointTrancheResult } from '@backsolve/shared-types';
import { usd } from '../../format/format';

export function AllocationTable({ allocation }: { allocation: BreakpointTrancheResult[] }) {
  if (allocation.length === 0) {
    return <p className="field-hint">No allocation tranches generated.</p>;
  }
  return (
    <div className="card">
      <div className="card-title">Allocation Table</div>
      <p className="result-caption">
        Each row is one waterfall tranche — the slice of equity value between two
        breakpoints — split pro-rata across the classes sharing that tranche. All
        values in USD.
      </p>
      <div className="table-wrap">
        <table className="data-table">
          <thead>
            <tr>
              <th>Tranche</th>
              <th>Classes</th>
              <th className="numeric">Tranche Value</th>
              <th>Per-Class</th>
            </tr>
          </thead>
          <tbody>
            {allocation.map((r) => (
              <tr key={r.breakpointIndex}>
                <td>#{r.breakpointIndex}</td>
                <td>{r.perClass.map((pc) => pc.instrumentId).join(', ')}</td>
                <td className="numeric">{usd(r.trancheValue)}</td>
                <td>
                  <ul>
                    {r.perClass.map((pc) => (
                      <li key={pc.instrumentId}>
                        {pc.instrumentId}: {usd(pc.value)}
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
